import "./insMapWidget.scss";
import React, { Fragment, useMemo } from "react";
import { InsWidgetTitle } from "../../base";
import { InsAzureMapWidgetContent } from "./insAzureMapWidgetContent";
import { InsMapLegend } from "./insMapLegend";
import { InsWidget } from "components";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useUnSelectedLegends, useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { InsMapFooter } from "./insMapFooter";
export const InsAzureMapWidget = (props) => {
    const { sectionId, widgetId } = props, unSelectedLegends = useUnSelectedLegends(sectionId, widgetId), widgetProps = useWidgetComponentProps(sectionId, widgetId), [[result], queryState] = useGetDatapointsWidgetData(props), [resultData] = result?.data || [];
    const filteredItems = resultData?.items?.filter((dataPoint) => {
        if (dataPoint.geometry.coordinates[0] === 0 || dataPoint.geometry.coordinates[1] === 0) {
            return false;
        }
        if (unSelectedLegends && dataPoint?.properties?.legend) {
            return !unSelectedLegends?.includes(dataPoint?.properties?.legend);
        }
        return true;
    }).map((element) => element);
    const assets = useMemo(() => resultData?.filteredAssetCount || 0, [resultData?.filteredAssetCount]);
    return React.createElement(InsWidget, { showMaximize: true, noMarginOnContent: true, ...props, content: React.createElement("div", { className: "ins-map-content" },
            React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState },
                React.createElement(Fragment, { key: props.widgetId + props.sectionId },
                    React.createElement(InsAzureMapWidgetContent, { colorSet: widgetProps.colorSet, data: filteredItems, unSelectedLegends: unSelectedLegends ?? [], isMaximized: props.isMaximizedOne ?? false }))),
            (Boolean(resultData?.items && resultData?.items?.length > 0) && widgetProps.showLegend) &&
                React.createElement("div", { className: "mapLegend" },
                    React.createElement(InsMapLegend, { items: resultData?.legend || [], ...props }))), title: React.createElement(InsWidgetTitle, { ...props, titleContainerClassName: "ins-map-title-container" }), footer: assets > 0 ? React.createElement(InsMapFooter, { itemCount: assets }) : undefined });
};
